import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

import styled from "styled-components";
import useWindowBreakpoint from "../components/hooks/UseWindowBreakpoint";

const CustomModal = styled(Modal)`
  .modal-lg {
    max-width: ${({ modalWidth }) => modalWidth};
  }

  .modal-header .close {
    display: none;
  }
  .modal-header {
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.body};
  }
  .modal-body {
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.body};
  }

  .card-header {
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.body};
  }
  .card-body {
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.body};
  }
`;

export const ConfirmModalContext = React.createContext(null);

export default function ConfirmModalProvider({ children }) {
  const [show, setShow] = useState(false);
  const [title, setTitle] = useState(null);
  const [content, setContent] = useState(null);
  const [confirmFunction, setConfirmFunction] = useState(() => defFunc);
  const [modalWidth, setModalWidth] = useState("500px");
  const [hidesButton, setHideButtons] = useState(true);

  const breakpoint = useWindowBreakpoint();

  // Funcion por defecto para confirmFunction. No hace nada
  function defFunc() {}
  // funcion que se exporta para poner confirmFunction correctamente
  function assignConfirmFunc(fn) {
    setConfirmFunction(() => fn);
  }

  useEffect(() => {
    // Si el viewport es pequeño ocultamos y si no mostramos
    if (["xs", "sm"].includes(breakpoint)) {
      setModalWidth("auto");
    } else {
      setModalWidth("500px");
    }
  }, [breakpoint]);

  // Recibe el estado del modal, true or false para mostrar la ventana
  // y recibe el tamaño de pantalla que ocupa el modal
  const showModal = (state, width = modalWidth, hideButtons = true) => {
    setShow(state);
    if (state) {
      // Si esta en formato movil lo cambiamos siempre a automático
      if (["xs", "sm"].includes(breakpoint)) {
        setModalWidth("auto");
      } else {
        setModalWidth(width);
      }

      setHideButtons(hideButtons);
    }
  };

  //Estado con las funciones que permiten interactuar con la ventana modal
  const state = {
    confirmModalSetShow: showModal,
    confirmModalSetTitle: setTitle,
    confirmModalSetContent: setContent,
    confirmModalSetFunction: assignConfirmFunc,
  };

  return (
    <ConfirmModalContext.Provider value={state}>
      <CustomModal modalwidth={modalWidth} show={show} scrollable size="lg" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{content}</Modal.Body>
        <Modal.Footer>
          {hidesButton && (
            <>
              <Button
                variant="outline-danger"
                onClick={() => {
                  confirmFunction();
                  setShow(false);
                }}
                name="Confirm"
              >
                {"Confirmar"}
              </Button>

              <Button
                variant="outline-primary"
                onClick={() => {
                  setShow(false);
                }}
                name="Close"
              >
                {"Cancelar"}
              </Button>
            </>
          )}
        </Modal.Footer>
      </CustomModal>
      {children}
    </ConfirmModalContext.Provider>
  );
}
